import { comment, forum } from '@/api'
import {
	FORUM_CATEGORIES_ERROR,
	FORUM_CATEGORIES_GET,
	FORUM_GET,
	FORUM_COMMENTS_GET,
	FORUM_CHOSE_CATEGORY,
	FORUM_CHOSE_CATEGORY_DELETE,
	FORUM_LOADING_STATUS,
	FORUMS_GET,
	FORUM_POST_ADD_STATUS,
	FORUM_POST_ADD,
	FORUM_POST_ADD_ERROR,
	FORUM_COMMENT_ADD_STATUS,
	FORUM_COMMENT_ADD,
	FORUM_COMMENT_ADD_ERROR,
	FORUM_EDIT_LOADING_STATUS,
	FORUM_ACTIVE_COMMENT,
	FORUM_MODAL_CATEGORY,
	FORUM_MODAL_CATEGORY_LOADING,
	FORUM_RESET_MODAL_CATEGORIES,
	FORUM_COMMUNITY_VIEW,
	FORUM_COMMUNITY_VIEW_LOADING,
	FORUM_COMMUNITY_VIEW_ERROR,
	FORUM_REPORT_MODAL,
	FORUM_SEND_REPORT,
	FORUM_SEND_REPORT_LOADING,
	FORUM_SEND_REPORT_ERROR,
} from '@/store/forum/types'

const getCommunity = async ({ commit }, communityId) => {
	commit(FORUM_COMMUNITY_VIEW_LOADING, true)
	try {
		const { data } = await forum.getCommunity(communityId)
		commit(FORUM_COMMUNITY_VIEW, data)
	} catch (e) {
		console.error(e)
		commit(FORUM_COMMUNITY_VIEW_ERROR, e)
	} finally {
		commit(FORUM_COMMUNITY_VIEW_LOADING, false)
	}
}

const setActiveComment = ({ commit }, payload) => {
	try {
		commit(FORUM_ACTIVE_COMMENT, payload)
	} catch (e) {
		console.error(e)
		throw e
	}
}
const getModalCategories = async (ctx, { query = '', page = 1 } = {}) => {
	ctx.commit(FORUM_MODAL_CATEGORY_LOADING, true)

	try {
		const { data, headers } = await forum.fetchForumCategories(`${query}&page=${page}`)
		const pageCount = headers['x-pagination-page-count']

		ctx.commit(FORUM_MODAL_CATEGORY, {
			data,
			pageCount,
			page,
		})
	} catch (e) {
		console.error(e)
	} finally {
		ctx.commit(FORUM_MODAL_CATEGORY_LOADING, false)
	}
}

const resetModalCategories = async (ctx) => {
	try {
		ctx.commit(FORUM_RESET_MODAL_CATEGORIES)
	} catch (e) {
		console.error(e)
	}
}

const fetchForumCategories = async (ctx, filters) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data, headers } = await forum.fetchForumCategories(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(FORUM_CATEGORIES_GET, response)
		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const fetchForums = async (ctx, query) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data, headers } = await forum.fetchForums(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(FORUMS_GET, response)
		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const getForum = async (ctx, forumId) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data: forumData } = await forum.getForum(forumId)
		const { data: forumCommentData } = await forum.getForumComments(forumId)

		ctx.commit(FORUM_GET, forumData)
		ctx.commit(FORUM_COMMENTS_GET, forumCommentData)

		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const addComment = async (ctx, commentData) => {
	ctx.commit(FORUM_COMMENT_ADD_STATUS, true)
	try {
		const { data } = await comment.addComment(commentData)

		ctx.commit(FORUM_COMMENT_ADD_STATUS, false)
		ctx.commit(FORUM_COMMENT_ADD, data)
	} catch (e) {
		ctx.commit(FORUM_COMMENT_ADD_ERROR, e)
		throw e
	}
}

const addPost = async (ctx, postData) => {
	ctx.commit(FORUM_POST_ADD_STATUS, true)
	try {
		const { data } = await forum.addPost(postData)

		ctx.commit(FORUM_POST_ADD_STATUS, false)
		ctx.commit(FORUM_POST_ADD, data)
	} catch (e) {
		ctx.commit(FORUM_POST_ADD_STATUS, false)
		ctx.commit(FORUM_POST_ADD_ERROR, e)
		throw e
	}
}

const chosenCategory = async (ctx, categoryId) => {
	try {
		ctx.commit(FORUM_CHOSE_CATEGORY, categoryId)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const deleteChosenCategory = async (ctx) => {
	try {
		ctx.commit(FORUM_CHOSE_CATEGORY_DELETE)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const editForum = async (ctx, payload) => {
	try {
		ctx.commit(FORUM_EDIT_LOADING_STATUS, true)

		const { data } = await forum.editForum(payload)

		ctx.commit(FORUM_GET, data)

		return data
	} catch (e) {
		console.log(e)
		throw e
	} finally {
		ctx.commit(FORUM_EDIT_LOADING_STATUS, false)
	}
}
const reportingModal = async (ctx) => {
	try {
		ctx.commit(FORUM_REPORT_MODAL)
	} catch (e) {
		console.error(e)
	}
}

const sendReport = async (ctx, data) => {
	ctx.commit(FORUM_SEND_REPORT_LOADING, true)

	try {
		await forum.sendReport(data)
		ctx.commit(FORUM_SEND_REPORT, data)
		return true
	} catch (e) {
		ctx.commit(FORUM_SEND_REPORT_ERROR, e)
		throw e
	} finally {
		ctx.commit(FORUM_SEND_REPORT_LOADING, false)
	}
}

export default {
	fetchForumCategories,
	fetchForums,
	getForum,
	addComment,
	chosenCategory,
	deleteChosenCategory,
	addPost,
	editForum,
	setActiveComment,
	getModalCategories,
	resetModalCategories,
	getCommunity,
	reportingModal,
	sendReport,
}
